import React, {useEffect, useState} from "react";
import NotificationIcon from "../../icons/NotificationIcon";
import CancelIcon from "../../icons/CancelIcon";
import EmptyBox2 from "../../icons/EmptyBox2";
import Notification from "./Notification";
import NotificationController from "../../../stories/_setting/Notifications/NotificationController";
import "../../../css/page/NotificationCenter.css";

const NotificationCenter = () => {
    const [ intervalNotification, setIntervalNotification ] = useState(null);
    const [ listNotifications, setListNotifications ] = useState([]);
    const [ notifications, setNotifications ] = useState([]);
    const [ nbUnread, setNbUnread ] = useState(0);
    const [ extendState, setExtendState ] = useState(false);
    const [ unread, setUnread ] = useState(false);
    const intervalSecond = 30000;

    const getNotifications = (initInterval = false) => {
        let controller = new NotificationController();
        controller._callback = returnGetNotifications;
        controller.index();

        if (initInterval) {
            let interNotification = setInterval(getNotifications, intervalSecond);
            setIntervalNotification(interNotification);
        }
    }
    const returnGetNotifications = (notifs, error, pagination, status) => {
        switch (status) {
            case 200:
                setNotifications(notifs);
                break;
            default: break;
        }
    }
    const checkNotifications = () => {
        let notificationsTmp = listNotifications.slice();
        let index;

        for (let i in notificationsTmp) {
            index = notifications.findIndex(_ => _.id === notificationsTmp[i].id);

            if (index < 0)
                notificationsTmp[i].read = 1;
            else
                notificationsTmp[i].read = notifications[index].read;
        }

        for (let i in notifications) {
            index = notificationsTmp.findIndex(_ => _.id === notifications[i].id);

            if (index < 0)
                notificationsTmp.push(notifications[i]);
        }

        notificationsTmp.sort((a, b) => {
            return new Date(b.created_at) - new Date(a.created_at);
        });

        setListNotifications(notificationsTmp);

        const unread = notifications.filter(_ => _.read === 0).length;
        setNbUnread(unread);
        setUnread(unread > 0);
    }
    const extend = () => {
        setExtendState(!extendState);
    }
    const readOne = id => {
        let notificationsTmp = listNotifications.slice();
        let index = notificationsTmp.findIndex(_ => _.id === id);

        if (index >= 0) {
            notificationsTmp[index].read = 1;
            setListNotifications(notificationsTmp);
        }
    }
    const readAll = () => {
        const controller = new NotificationController();
        controller.readAll();

        let notificationsTmp = listNotifications.slice();

        for (let i in notificationsTmp)
            notificationsTmp[i].read = 1;

        setListNotifications(notificationsTmp);
    }

    useEffect(() => {
        getNotifications(true);
    }, []);
    useEffect(() => {
        return() => {
            clearInterval(intervalNotification);
        }
    }, [intervalNotification]);
    useEffect(() => {
        checkNotifications();
    }, [notifications]);

    return (
        <>
            <div className="iconNotification" onClick={extend}>
                <NotificationIcon />
                { unread && <div className={"unread"} /> }
            </div>
            <div className={"notificationCenter" + (extendState ? " opened" : "")}>
                <div className={"containerTitle" + (!unread ? " marginBottom" : "")}>
                    <p className={"title"}>Notifications<span>{ (nbUnread > 0 ? " (" + nbUnread + " non lue" + (nbUnread > 1 ? "s" : "") + ")" : "") }</span></p>
                    <CancelIcon classname={"close"} click={extend} />
                </div>
                <div className={"containerList"}>
                    {
                        unread
                        && <p className={"readAll"} onClick={readAll}>Marquer tout comme lu</p>
                    }
                    <div className={"list" + (!unread ? " noUnreadAll" : "")}>
                        {
                            listNotifications.length > 0
                                ? listNotifications.map((notif, index) => (
                                    <Notification key={index} notification={notif} refresh={readOne} />
                                ))
                                : <div className={"empty"}>
                                    <EmptyBox2 />
                                    <p>Aucune notification</p>
                                </div>
                        }
                    </div>
                </div>
            </div>
        </>
    );
}

export default NotificationCenter;